const BookmarkHandler = {
  init(btnBookmarkAyah) {
    this._checkBookmarkStatus(btnBookmarkAyah);
    this._bookmarkListener(btnBookmarkAyah);
  },

  _bookmarkListener(btnBookmarkAyah) {
    btnBookmarkAyah.forEach((btn) => {
      const radioBtn = btn.previousElementSibling;
      const saveIcon = btn.firstElementChild;
      const unsaveIcon = btn.lastElementChild;
      const surahNumber = btn.getAttribute('surahNumber');
      const surahName = btn.getAttribute('surahName');
      const ayahNumber = btn.getAttribute('ayahNumber');
      const numAyahQuran = btn.getAttribute('numAyahQuran');
      const tooltipBookmarkAyah = document.querySelector(`#tooltip-bookmark-ayah-${numAyahQuran}`);
      const bookmark = {
        surahNumber, surahName, ayahNumber, numAyahQuran,
      };
      radioBtn.addEventListener('click', () => this._updateBookmarkStatus({
        btnBookmarkAyah, bookmark, radioBtn, saveIcon, unsaveIcon, tooltipBookmarkAyah,
      }));
    });
  },

  _updateBookmarkStatus({
    btnBookmarkAyah, bookmark, radioBtn, saveIcon, unsaveIcon, tooltipBookmarkAyah,
  }) {
    localStorage.setItem('BOOKMARK', JSON.stringify(bookmark));
    this._checkBookmarkStatus(btnBookmarkAyah);
    if (unsaveIcon.classList.contains('hidden')) {
      radioBtn.checked = saveIcon.classList.contains('hidden');
      localStorage.removeItem('BOOKMARK');
    } else {
      tooltipBookmarkAyah.classList.remove('invisible');
      setTimeout(() => {
        tooltipBookmarkAyah.classList.add('invisible');
      }, 1500);
    }
  },

  _checkBookmarkStatus(btnBookmarkAyah) {
    const bookmark = JSON.parse(localStorage.getItem('BOOKMARK'));
    if (bookmark) {
      btnBookmarkAyah.forEach((btn) => {
        const radioBtn = btn.previousElementSibling;
        const saveIcon = btn.firstElementChild;
        const unsaveIcon = btn.lastElementChild;
        const numAyahQuran = btn.getAttribute('numAyahQuran');
        const isBookmark = bookmark.numAyahQuran === numAyahQuran;
        let isActive = radioBtn.checked;
        if (isBookmark) isActive = true;
        if (isActive) {
          saveIcon.classList.toggle('hidden');
          unsaveIcon.classList.toggle('hidden');
        }
        if (isActive === false) {
          saveIcon.classList.remove('hidden');
          unsaveIcon.classList.add('hidden');
        }
      });
    }
  },
};

export default BookmarkHandler;
